<svg
  class="container"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  xml:space="preserve"
  viewBox="0 0 500 500"
  [style.--bulb-avatar-bg]="color.background"
  [style.--bulb-avatar-text]="color.text"
>
  <defs>
    <clipPath id="clipCircle">
      <circle cx="250" cy="250" r="240" />
    </clipPath>
  </defs>
  <circle
    cx="250"
    cy="250"
    r="240"
  />
  <text
    *ngIf="displayProps.subjectType === 'BULB_USER'"
    x="50%"
    y="50%"
    text-anchor="middle"
    dy="0.3em"
  >
    {{ displayProps.initials }}
  </text>

  <g
    class="fallback-icon"
    *ngIf="!displayProps.initials"
    [innerHTML]="fallbackIcon"
  ></g>

  <image
    *ngIf="displayProps.avatarImage"
    [attr.href]="displayProps.avatarImage.url"
    height="500"
    width="500"
    clip-path="url(#clipCircle)"
  />
</svg>
